/* eslint-disable no-plusplus */
/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import ReCAPTCHA from 'react-google-recaptcha';
import EmptyResult from 'components/atoms/empty_result';
import SelectButton from 'components/atoms/select_button';
import ItemTools from 'components/molecules/item_tools';
import { getDownloadBulletin, getPrintBulletin } from 'services/actions/bulletins';
import ItemShare from 'components/atoms/item_share';
import InAnalysisAlert from 'components/molecules/in_analysis_alert';
import {
  BulletinBiddingsTypes,
  BulletinsState,
  BulletinsTypes,
} from 'store/modules/bulletins_store/types';
import Pagination from 'components/atoms/pagination';
import { spliceArray } from 'services/splice_array';
import { toggleSelected } from 'services/toggleSelected';
import _ from 'underscore';
import Select from 'react-select';
import { StatesList } from 'services/states';
import BulletinSelectedItemLabel from 'components/atoms/bulletin_selected_item_label';
import TotalEntriesLabel from 'components/atoms/total_entries_label';
import BiddingItemNew from 'components/molecules/bidding_item_new';
import { Container } from './styles';

interface BulletinBiddingsProps {
  bulletin_filter_id: number;
  bulletinFilterIndex: number;
  selectedBiddings: Array<number>;
  selectedFollowups: Array<number>;
  setSelectedBiddings: React.Dispatch<React.SetStateAction<Array<number>>>;
  setSelectedFollowups: React.Dispatch<React.SetStateAction<Array<number>>>;
  toogleSelectWholeBulletin: () => void;
  wholeBulletinSelected: boolean;
  showMatch?: boolean;
}

interface SelectValuesTypes {
  value: number | boolean;
  label: string;
}

const BulletinBiddings = (props: BulletinBiddingsProps) => {
  const PAGE_SIZE = 50;
  const {
    bulletin_filter_id,
    bulletinFilterIndex,
    selectedBiddings,
    setSelectedBiddings,
    selectedFollowups,
    setSelectedFollowups,
    toogleSelectWholeBulletin,
    wholeBulletinSelected,
    showMatch = false,
  } = props;
  const dispatch = useDispatch();
  const { bulletins, request } = useSelector<ApplicationState, BulletinsState>(
    (state) => state.session.bulletins,
  );

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const matchOnlyFilter = bulletins?.match_only_filter || false;
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false);
  const [token, setToken] = useState<string | null>(null);
  const [showShareWindow, setShowShareWindow] = useState<boolean>(false);
  const [scrollToolsClass, setScrollToolsClass] = useState<string>('');
  const [wholePageSelected, setWholePageSelected] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(
    bulletins.bulletins_biddings_list[bulletin_filter_id]?.current_page || 1,
  );
  const [biddingList, setBiddingList] = useState<Array<BulletinBiddingsTypes>>([]);
  const [situationsFilter, setSituationsFilter] = useState<Array<SelectValuesTypes>>([]);
  const [statesFilter, setStatesFilter] = useState<Array<SelectValuesTypes>>([]);
  const [selectedSituationsFilter, setSelectedSituationsFilter] = useState<
    Array<SelectValuesTypes>
  >([]);
  const [selectedStatesFilter, setSelectedStatesFilter] = useState<Array<SelectValuesTypes>>([]);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<Array<SelectValuesTypes>>([]);
  const [filteredList, setFilteredList] = useState<Array<BulletinBiddingsTypes>>([]);
  const [biddingsCount, setBiddingsCount] = useState<number>(0);
  const [loadedFilters, setLoadedFilters] = useState<boolean>(false);
  const statusFilter = [
    {
      value: false,
      label: 'Não lida',
    },
    {
      value: true,
      label: 'Lida',
    },
  ];

  const recaptchaRef = React.createRef<ReCAPTCHA>();
  const componentRef = useRef() as React.MutableRefObject<HTMLInputElement>;

  const toggleSelectedBiddings = (id: number, updateAll = false) => {
    toggleSelected({
      id,
      updateAll,
      selectedList: selectedBiddings,
      setSelectedList: setSelectedBiddings,
      sourceList: biddingList,
      wholePageSelected,
    });
  };

  const updateCurrentPage = (currentPage = 1) => {
    dispatch({
      type: BulletinsTypes.UPDATE_CURRENT_PAGE_BIDDINGS,
      current_page: currentPage,
      bulletin_id: bulletin_filter_id,
    });
    setCurrentPage(currentPage);

    document.querySelector('#windowDiv')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const pages = Array.from(
      { length: bulletins.bulletins_biddings_list[bulletin_filter_id].total_pages },
      (_, i) => i + 1,
    ).map((page) => `bulletin_${bulletin_filter_id}_page_${page}`);

    const isNotLoaded = pages.find((page) => {
      if (!request.fetch_bulletin_biddings[page]) return true;
      if (!request.fetch_bulletin_biddings[page]?.loaded) return true;

      return false;
    });

    if (!isNotLoaded) setLoadedFilters(true);
    if (isNotLoaded) setLoadedFilters(false);
  }, [request?.fetch_bulletin_biddings, bulletins.bulletins_biddings_list]);

  useEffect(() => {
    const windowDiv = document.getElementById('windowDiv');
    windowDiv?.addEventListener('scroll', () => {
      setScrollToolsClass(windowDiv?.scrollTop > 10 ? 'border-bottom' : '');
    });

    if (!bulletins.bulletins_biddings_list[bulletin_filter_id]) return;

    setBiddingsCount(bulletins?.bulletins_biddings_list[bulletin_filter_id]?.total_entries);
    setCurrentPage(bulletins?.bulletins_biddings_list[bulletin_filter_id]?.current_page);
  }, []);

  useEffect(() => {
    if (!loadedFilters) return;

    const stateIds = _.uniq(
      bulletins.bulletins_biddings_list[bulletin_filter_id].biddings.map(
        (bidding) => bidding.orgao_estado_id,
      ),
    ).map((stateId) => StatesList.find((state) => state.id === stateId));

    setStatesFilter(
      stateIds.map((state) => {
        return {
          value: state?.id || 0,
          label: state?.name || '',
        };
      }),
    );

    setSituationsFilter(
      _.uniq(
        bulletins.bulletins_biddings_list[bulletin_filter_id].biddings.map((bidding) => {
          return {
            value: bidding.bidding_grouping.id || 0,
            label: bidding.bidding_grouping.resumo || '',
          };
        }),
        (item) => {
          return item.value;
        },
      ),
    );
  }, [loadedFilters]);

  useEffect(() => {
    setBiddingsCount(filteredList.length);

    if (filteredList.length === 0) {
      setBiddingList([]);
      return;
    }

    setBiddingList(spliceArray(filteredList, PAGE_SIZE)[currentPage - 1]);
  }, [currentPage, filteredList]);

  useEffect(() => {
    if (!biddingList) return;

    setWholePageSelected(
      biddingList
        ?.map((bidding) => Number(bidding.bidding_id))
        .filter((bidding) => selectedBiddings.includes(bidding))?.length === biddingList.length,
    );
  }, [
    selectedBiddings,
    bulletins.bulletins_biddings_list[bulletin_filter_id]?.current_page,
    biddingList,
  ]);

  useEffect(() => {
    const storeStatusFilter = bulletins.status_filter || [];
    if (storeStatusFilter.length > 0) {
      const newSelected = statusFilter.filter((s) => storeStatusFilter.includes(s.value));
      setSelectedStatusFilter(newSelected);
    } else {
      setSelectedStatusFilter([]);
    }
  }, [bulletins.status_filter]);

  useEffect(() => {
    if (!bulletins.bulletins_biddings_list[bulletin_filter_id]?.biddings) return;

    const selectedSituationIds = selectedSituationsFilter.map((situation) => situation.value);
    const selectedStatesIds = selectedStatesFilter.map((state) => state.value);
    const selectedStatus = selectedStatusFilter.map((state) => state.value);

    let newFilteredList = bulletins.bulletins_biddings_list[bulletin_filter_id].biddings;

    if (selectedSituationIds.length > 0) {
      newFilteredList = newFilteredList.filter((bidding) => {
        if (bidding.bidding_grouping.id) {
          if (selectedSituationIds.includes(bidding?.bidding_grouping?.id)) return true;
        }
        return false;
      });
    }
    if (selectedStatesIds.length > 0) {
      newFilteredList = newFilteredList.filter((bidding) =>
        selectedStatesIds.includes(bidding?.orgao_estado_id),
      );
    }

    if (selectedStatus.length > 0) {
      newFilteredList = newFilteredList.filter((bidding) =>
        selectedStatus.includes(bidding?.viewed_by_user),
      );
    }

    if (showMatch && matchOnlyFilter) {
      newFilteredList = newFilteredList.filter(
        (bidding) =>
          bidding?.match?.prioridade === 'Alta' || bidding?.match?.prioridade === 'Média',
      );
    }

    setFilteredList(newFilteredList);
  }, [
    selectedSituationsFilter,
    selectedStatesFilter,
    selectedStatusFilter,
    matchOnlyFilter,
    bulletins.bulletins_biddings_list[bulletin_filter_id]?.biddings,
  ]);

  useEffect(() => {
    if (selectedSituationsFilter.length > 0 || selectedStatesFilter.length > 0) {
      updateCurrentPage();
      setSelectedBiddings([]);
    }
  }, [selectedSituationsFilter, selectedStatesFilter]);

  useEffect(() => {
    if (!showMatch) return;

    updateCurrentPage();
    setSelectedBiddings([]);
  }, [matchOnlyFilter]);

  const downloadFile = (fileExtension: string) => {
    getDownloadBulletin(
      fileExtension,
      'bidding',
      bulletin_filter_id,
      wholeBulletinSelected ? [] : selectedBiddings,
      bulletins.filter_bulletins[bulletinFilterIndex]?.bulletin_filters?.filter(
        (bulletin_filter) => bulletin_filter?.id === bulletin_filter_id,
      )[0].issue,
      bulletins.filter_bulletins[bulletinFilterIndex]?.filter?.description,
    );
  };

  const handleShare = () => {
    setShowShareWindow(!showShareWindow);
  };

  const handlePrint = () => {
    getPrintBulletin('bidding', bulletin_filter_id, wholeBulletinSelected ? [] : selectedBiddings);
  };

  return (
    <Container>
      {profile.enable_captcha && showCaptcha === true && token === null && (
        <div className="w-100 d-flex justify-content-center mt-5">
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Lcex2sdAAAAAKMks7alzUBCyRFy88kgqM07DcwW"
            onChange={(recaptchaToken: React.SetStateAction<string | null>) => {
              setShowCaptcha(false);
              setToken(recaptchaToken);
            }}
            hl="pt-BR"
          />
        </div>
      )}
      {profile.enable_captcha && showCaptcha === false && token === null && (
        <div className="d-flex justify-content-center mt-5">
          <button
            type="button"
            className="btn btn-success btn-sm mr-1"
            onClick={() => {
              setShowCaptcha(true);
            }}
            disabled={showCaptcha}
          >
            Ver Licitações
          </button>
        </div>
      )}

      <div className="row d-print-none position-relative" style={{ zIndex: '101' }}>
        <div className="col-md-4 col-12 mb-3 mb-md-0">
          <div className="mb-1">Situação</div>
          <Select
            isLoading={!loadedFilters}
            loadingMessage={() => 'Carregando situações'}
            name="SituationFilterSearch"
            isMulti
            value={selectedSituationsFilter}
            closeMenuOnSelect={false}
            onChange={(event) => setSelectedSituationsFilter([...event])}
            options={loadedFilters ? situationsFilter : []}
            placeholder={loadedFilters ? 'Filtre por situação' : 'Carregando situações'}
            className="basic-multi-select"
            noOptionsMessage={() => 'Sem opções'}
          />
        </div>
        <div className="col-md-4 col-12">
          <div className="mb-1">Estados</div>
          <Select
            isLoading={!loadedFilters}
            loadingMessage={() => 'Carregando estados'}
            name="StateFilterSearch"
            isMulti
            value={selectedStatesFilter}
            closeMenuOnSelect={false}
            onChange={(event) => setSelectedStatesFilter([...event])}
            options={loadedFilters ? statesFilter : []}
            placeholder={loadedFilters ? 'Filtre por estado' : 'Carregando estados'}
            className="basic-multi-select"
            noOptionsMessage={() => 'Sem opções'}
          />
        </div>
        <div className="col-md-4 col-12">
          <div className="mb-1">Status</div>
          <Select
            isLoading={!loadedFilters}
            loadingMessage={() => 'Carregando status'}
            name="StatusFilterSearch"
            isMulti
            value={selectedStatusFilter}
            closeMenuOnSelect={false}
            onChange={(event) => setSelectedStatusFilter([...event])}
            options={loadedFilters ? statusFilter : []}
            placeholder={loadedFilters ? 'Filtre por status' : 'Carregando status'}
            className="basic-multi-select"
            noOptionsMessage={() => 'Sem opções'}
          />
        </div>
      </div>

      {request?.fetch_bulletin_biddings[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
        ?.loaded &&
        (!profile.enable_captcha || token !== null) &&
        (!profile.in_analysis ||
          (profile.in_analysis &&
            bulletins.bulletins_biddings_list[bulletin_filter_id]?.current_page === 1)) &&
        bulletins.bulletins_biddings_list[bulletin_filter_id]?.biddings?.length > 0 && (
          <div className="row">
            <div className="col-12 mx-auto px-0 px-md-3">
              <div className={`row list-tools py-1 ${scrollToolsClass}`}>
                {biddingList?.length > 0 && (
                  <>
                    <div className="position-relative col-lg-6 d-block py-3 px-md-2 px-4">
                      <SelectButton
                        isChecked={wholePageSelected}
                        id={0}
                        toggleSelected={toggleSelectedBiddings}
                        text="Selecionar página"
                      />
                      <SelectButton
                        isChecked={wholeBulletinSelected}
                        id={0}
                        toggleBulletin={toogleSelectWholeBulletin}
                        text="Selecionar boletim"
                      />
                      <BulletinSelectedItemLabel
                        selectedBiddings={selectedBiddings}
                        selectedFollowups={selectedFollowups}
                        setSelectedBiddings={setSelectedBiddings}
                        setSelectedFollowups={setSelectedFollowups}
                      />
                    </div>
                    <ItemTools
                      enabledButtons={selectedBiddings?.length > 0}
                      disabledPopoverLabel="a licitação"
                      downloadFile={downloadFile}
                      handleShare={handleShare}
                      handlePrint={handlePrint}
                    />
                  </>
                )}
                {showShareWindow && (
                  <ItemShare
                    setShowShareWindow={setShowShareWindow}
                    selectedItems={selectedBiddings}
                  />
                )}
              </div>
              <div className="row">
                <div className="col-md-12 d-flex align-items-center justify-content-end text-secondary">
                  <TotalEntriesLabel
                    itemLabel={biddingsCount === 1 ? 'licitação' : 'licitações'}
                    totalEntries={biddingsCount}
                  />
                </div>
              </div>
              {profile.in_analysis && <InAnalysisAlert />}
              <div ref={componentRef} className="row mx-0 mt-5">
                <div className="col-12">
                  {request?.fetch_bulletin_biddings[
                    `bulletin_${bulletin_filter_id}_page_${currentPage}`
                  ]?.loaded &&
                    biddingList?.length === 0 &&
                    selectedSituationsFilter.length > 0 &&
                    selectedStatesFilter.length > 0 && (
                      <EmptyResult
                        title="Desculpe!"
                        description="Não temos licitações que correspondam a esses filtros."
                      />
                    )}

                  {request?.fetch_bulletin_biddings[
                    `bulletin_${bulletin_filter_id}_page_${currentPage}`
                  ]?.loaded &&
                    biddingList?.map((bidding, index) => (
                      <BiddingItemNew
                        key={bidding.bidding_id}
                        bulletinFilterIndex={bulletinFilterIndex}
                        bidding={bidding}
                        biddingIndex={
                          index +
                          (Number(
                            bulletins?.bulletins_biddings_list[bulletin_filter_id]?.current_page,
                          ) -
                            1) *
                            PAGE_SIZE
                        }
                        isChecked={selectedBiddings.includes(Number(bidding.bidding_id))}
                        toggleSelected={toggleSelectedBiddings}
                        favoritedSource="bulletin"
                        bulletinFilterId={bulletin_filter_id}
                        source="bulletin"
                        commentSource="bulletin"
                        showMatch={showMatch}
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      {request?.fetch_bulletin_biddings[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
        ?.error && (
        <EmptyResult title="Desculpe!" description="Algo deu errado, tente novamente." />
      )}
      {request?.fetch_bulletin_biddings[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
        ?.loaded &&
        (!profile.enable_captcha || token !== null) &&
        (!profile.in_analysis ||
          (profile.in_analysis &&
            bulletins.bulletins_biddings_list[bulletin_filter_id]?.current_page === 1)) &&
        bulletins.bulletins_biddings_list[bulletin_filter_id]?.biddings?.length === 0 && (
          <div className="col-md-12 text-center">
            <h2 className="text-secondary mt-3">Resultado não encontrado.</h2>
            <h5 className="text-secondary mt-3">
              Esse boletim não tem licitações ou não temos licitações que correspondam a esses
              filtros.
            </h5>
          </div>
        )}
      {request?.fetch_bulletin_biddings[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
        ?.loaded &&
        profile.in_analysis &&
        bulletins.bulletins_biddings_list[bulletin_filter_id].current_page !== 1 && (
          <div className="alert alert-warning">
            Estamos finalizando a liberação do seu cadastro, aguarde que em breve todos os avisos de
            licitação estarão disponíveis para você.
          </div>
        )}
      {request?.fetch_bulletin_biddings[`bulletin_${bulletin_filter_id}_page_${currentPage}`]
        ?.loaded &&
        bulletins.bulletins_biddings_list[bulletin_filter_id]?.total_entries > PAGE_SIZE &&
        bulletins.bulletins_biddings_list[bulletin_filter_id]?.total_entries !== 0 && (
          <div className="row d-print-none">
            <div className="col-12 mx-auto mb-1 pb-1 px-4">
              <Pagination
                postsPerPage={PAGE_SIZE}
                totalPosts={filteredList.length}
                paginate={updateCurrentPage}
                currentPage={bulletins?.bulletins_biddings_list[bulletin_filter_id]?.current_page}
                firstAndLastPage
              />
            </div>
          </div>
        )}
    </Container>
  );
};

export default BulletinBiddings;
